import { useContext } from "react";
import { AppContext } from "components/AppContext";
import { MonthDayYearInput } from "./MonthDayYearInput";
import { SingleBirthdateInput } from "./SingleBirthdateInput";

export default function BirthDate({ date, onDateComplete, onDateError }) {
  const { newQuiz } = useContext(AppContext);

  return (
    <>
      {newQuiz.isClinical ? (
        <SingleBirthdateInput
          date={date}
          onDateComplete={onDateComplete}
          onDateError={onDateError}
        />
      ) : (
        <MonthDayYearInput date={date} onDateComplete={onDateComplete} />
      )}
    </>
  );
}
